import { Button, Divider } from '@mui/material';
import { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import type { ITheme } from '../../../theme';
import { COMPANY_URL } from '../../../utils';
import { AppConstantsContext } from '../../../context';

const useStyles = makeStyles()((theme: ITheme) => ({
  mainRow: {
    background: theme.gradients.primaryGradient,
    color: '#fff',

    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },

  divider: {
    width: theme.spacing(0.2),
    background: theme.palette.grey.A100,
    marginTop: theme.spacing(0.8),
    marginBottom: theme.spacing(0.8),
  },
}));

const CompactFooter = (): JSX.Element => {
  const { classes } = useStyles();
  const { helpLink, isMusehub } = useContext(AppConstantsContext);
  const { t } = useTranslation();

  if (isMusehub) return null;

  return (
    <div className={classes.mainRow}>
      <Button id="btn_songbook_footer_company" color="inherit" size="small" href={COMPANY_URL}>
        Klangio
      </Button>
      <Divider
        orientation="vertical"
        variant="middle"
        classes={{ root: classes.divider }}
        flexItem
      />
      <Button id="btn_songbook_footer_help" color="inherit" size="small" href={helpLink}>
        {t('footer.help')}
      </Button>
      <Divider
        orientation="vertical"
        variant="middle"
        classes={{ root: classes.divider }}
        flexItem
      />
      <Button
        id="btn_songbook_footer_imprint"
        color="inherit"
        size="small"
        href={`${COMPANY_URL}/imprint`}
      >
        {t('footer.imprint')}
      </Button>
      <Divider
        orientation="vertical"
        variant="middle"
        classes={{ root: classes.divider }}
        flexItem
      />
      <Button
        id="btn_songbook_footer_privacy"
        color="inherit"
        size="small"
        href={`${COMPANY_URL}/privacy`}
      >
        {t('footer.privacy')}
      </Button>
      <Divider
        orientation="vertical"
        variant="middle"
        classes={{ root: classes.divider }}
        flexItem
      />
      <Button
        id="btn_songbook_footer_feedback"
        color="inherit"
        size="small"
        href={`${COMPANY_URL}/about-us/contact/`}
      >
        {t('footer.feedback')}
      </Button>
      <Divider
        orientation="vertical"
        variant="middle"
        classes={{ root: classes.divider }}
        flexItem
      />
      <Button
        id="btn_songbook_footer_gift_cards"
        color="inherit"
        size="small"
        href={`${COMPANY_URL}/gift-cards`}
      >
        {t('footer.gift-cards')}
      </Button>
    </div>
  );
};

export default CompactFooter;
